__webpack_require__.p = "/draw-and-guess/";